document.addEventListener('DOMContentLoaded', function () {
    const skipLink = document.getElementById('skip-main');
    const main = document.getElementById('main');

    skipLink.href = window.location.pathname + '#main';

    skipLink.addEventListener('click', function (e) {
      if (main) {
        e.preventDefault();
        main.setAttribute('tabindex', '-1');
        main.focus();
        window.scrollTo({ top: main.offsetTop, behavior: 'smooth' });
      }
    });
  });